module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_innlandet_neg.6940dda3.pdf";